// extracted by mini-css-extract-plugin
module.exports = {"page":"Listen_page__3VVZy","card":"Listen_card__oGAzX","eyebrow":"Listen_eyebrow__1Eq0X","title":"Listen_title__2P-fT","by":"Listen_by__3Uh8Y","audio":"Listen_audio__1mIvZ"};